import { useEffect, useState } from 'react'
import { getAllLanguages } from '../services/micro';

const useGetLanguages = (user, storedLanguage) => {
    const [languages, setLanguages] = useState([]);
    const [selectedLanguage, setSelectedLanguage] = useState(null);

    useEffect(() => {
        getAllLanguages()
          .then((res) => {
            if (res?.success) {
              // const allowedLanguages = ["EN", "ES", "DE", "FR", "IT", "PT"];
              const allowedLanguages = ["EN", "FR"];
              const languagesData = res.data.filter(({language_code}) => allowedLanguages.includes(language_code)).map((lang) => ({
                value: lang.language_code,
                label: lang.name
              }))
              setLanguages(languagesData);
    
              if (user.language) {
                setSelectedLanguage(user.language)
              } else if (storedLanguage) {
                setSelectedLanguage(storedLanguage)
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }, []);

      return { languages, selectedLanguage, setSelectedLanguage}
}

export default useGetLanguages
